export enum FinancialType {
  EXPENSE = 'Expense',
  INCOME = 'Income',
}
